import React from 'react';
import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { useNavigate } from 'react-router-dom';
import { User, Lock } from 'lucide-react';
import { useAuth } from '@/hooks';
import { loginSchema, type LoginFormData } from '@/utils/validators';
import { Input, Button } from '@/components/common';
import { ROUTES } from '@/utils/constants';
import toast from 'react-hot-toast';

export const LoginForm: React.FC = () => {
  const navigate = useNavigate();
  const { login, isLoading, error, clearError } = useAuth();
  
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  const onSubmit = async (data: LoginFormData) => {
    try {
      clearError();
      await login(data.username, data.password);
      toast.success('تم تسجيل الدخول بنجاح');
      navigate(ROUTES.SEARCH);
    } catch (err) {
      // Error is handled by the store
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark p-4">
      <div className="w-full max-w-md">
        <div className="card">
          <div className="text-center mb-8">
            <img src="/logo.png" alt="Logo" className="h-24 w-auto mx-auto mb-6 object-contain" />
            <h1 className="text-2xl font-bold text-primary mb-2">
              نظام إدارة مخزون البطاريات
            </h1>
            <p className="text-gray-400">قم بتسجيل الدخول للمتابعة</p>
          </div>

          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
            <Input
              label="اسم المستخدم"
              type="text"
              placeholder="أدخل اسم المستخدم"
              icon={<User className="h-5 w-5" />}
              error={errors.username?.message}
              {...register('username')}
            />

            <Input
              label="كلمة المرور"
              type="password"
              placeholder="أدخل كلمة المرور"
              icon={<Lock className="h-5 w-5" />}
              error={errors.password?.message}
              {...register('password')}
            />

            {error && (
              <div className="bg-danger/20 border border-danger/30 rounded-lg p-3 text-danger text-sm">
                {error}
              </div>
            )}

            <Button
              type="submit"
              variant="primary"
              className="w-full"
              isLoading={isLoading}
              disabled={isLoading}
            >
              تسجيل الدخول
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};
